import React, { Fragment } from 'react';
import cn from 'classnames';
import { Link } from 'gatsby';
import Icon from '@components/Icon';

import styles from './index.module.css';

const Item = ({ to, activeClassName, ...props }) => {
    if (to.startsWith('http')) {
        return <a href={to} target="_blank" {...props} />;
    }
    return <Link to={to} activeClassName={activeClassName} {...props} />;
};

const renderLabel = (label, icon, iconOnly) => {
    if (icon && label && !iconOnly) {
        return (
            <Fragment>
                <Icon icon={icon} /> {label}
            </Fragment>
        );
    }
    if (icon) return <Icon icon={icon} />;
    return label;
};

const Navigation = ({ items, icons, className }) => (
    <nav className={cn(styles.nav, className)}>
        {items.map(({ id, label, title, icon, iconOnly, to }) => (
            <Item
                key={id}
                to={to}
                title={title}
                className={styles.item}
                activeClassName={styles.itemActive}
            >
                {renderLabel(label, icon, iconOnly)}
            </Item>
        ))}
    </nav>
);

export default Navigation;
